module.exports = __webpack_public_path__ + "static/media/pagina1-boompje1_tijdslijn.23b22fdd.svg";